// savedAnalysesAnalytics.js — Customer Value telemetry, Slice 1 (Saved Analyses)
//
// Thin, declarative wrappers over lib/analytics.track for the saved-analysis
// lifecycle. `analysis_saved` (DealAnalyzer) already exists and is REUSED — this
// module adds only the return/reopen/delete lifecycle. track() injects the
// BL-025 `environment` tag and no-ops when PostHog is unconfigured.
//
// PII-safe (ADR-040): counts/flags/enums only — never an address, deal payload,
// or free-text.

import { track } from './analytics';

// The user returns to their saved analyses (customer-return signal, M-017).
export function savedAnalysisViewed({ count = 0, ...rest } = {}) {
  track('saved_analysis_viewed', { count, has_saved: count > 0, ...rest });
}

// The user reopens a saved analysis into the Deal Analyzer (reopen signal, M-018).
export function savedAnalysisOpened(props = {}) {
  track('saved_analysis_opened', props);
}

export function savedAnalysisDeleted(props = {}) {
  track('saved_analysis_deleted', props);
}
